<template>
  <div class="products-consititue bg-center" :style="{height: '40%', width: '100%',maxWidth: '540px'}" >
    <div id="productscons-charts" :style="{height: '100%', width: '100%'}"></div>
	<div class="left-bg-title bg-center pd10tb">
		<img src="../../assets/images/icon2.png" class="icon"/>
		产品赋码构成
	</div>
  </div>
</template>

<script>
//引入静态数据文件
// import ProdConsData from "../../assets/staticData/prodCon";
import {getOrgcodeData} from "../../api/region.js";
import {mapState} from "vuex";
export default {
  data(){
	  return {
		ProdConsData:{
			xAxisData:[],
			seriesData:[]
		},
		timer:null,
		Dom:null,
	  }
  },
  watch:{
	async codeData(val)
	{
		if(val != '')
		{
			await val.forEach(item => {
				this.ProdConsData.xAxisData.push(item.date)
				this.ProdConsData.seriesData.push(item.unique_code)
			})
		}
		if(typeof this.Dom != 'null') {
			this.setTime()
		}
	}
  },
  mounted() {
	  this.Dom = document.getElementById("productscons-charts");
      //this.prodConsDrawLine();
  },
  computed:{
	...mapState(['codeData']),  
  },
  methods: {
    prodConsDrawLine() {
      //实例化echarts
      const prodConsDom = this.Dom;
      const prodConsChart = this.$echarts.init(prodConsDom);
	  prodConsChart.clear()
      let option = {
           tooltip: {
          trigger: "axis"
        },
		animationDuration: 3000,
        xAxis: {
          data: this.ProdConsData.xAxisData,
          axisLabel: {
            color: "#468f72",
            textStyle: {
              fontSize: 9,
			  color: "rgba(255,255,255,.5)",
            }
          },
          
        },
        grid: {},
        yAxis: {
          type: "value",
          data: ["0", "5", "10", "15", "20"],
          axisLabel: {
            color: "#468f72",
            textStyle: {
              fontSize: 9,
			  color: "rgba(255,255,255,.5)",
            }
          },
           splitLine: {
        show: true,
        lineStyle:{
           color: ['#25373a'],
           width: 1,
           type: 'solid'
      }
　　}
        },
        series: [
          {
            name: "销量",
            type: "bar",
            data: this.ProdConsData.seriesData,
            barWidth: "25",
            itemStyle: {
              normal: {
                color: "#60ab90",
                offset: 0
              }
            }
          }
        ]
      }
      prodConsChart.setOption(option);
    },
	setTime() {
		let nowTime = new Date();
		let that = this;
		this.prodConsDrawLine();
		this.clearTimer();
		this.timer = setTimeout(function() {
			if(new Date() - nowTime > 800)
			{
				that.setTime()
			}
		}, 6000);
	},
	//清除定时
	clearTimer()
	{
		clearInterval(this.timer);
		this.timer = null;
	}
  }
};
</script>

<style lang='less'>
.products-consititue {
    margin-top: 10px;
  position: relative;
  background-image: url("../../assets/images/products-info.png");
}
.left-bg-title{
background: none;
    line-height: 20px;
    left: 10px;
    top: 7px;
    color: #4FCCFF;
    width: auto;
    min-width: auto;
    max-width: 130px;
}
.left-bg-title .icon{
	width: 20px;
	height: 20px;
	float: left;
	margin-right: 8px;
}
</style>